import "../tool.js";
(function (Tool, Event) {
  "use strict";

  // Nested `load()` calls share one `pb:tools:load:start`/`pb:tools:load:done` pair, fired by the outermost call.
  var loadDepth = 0;

  function Loader(component, container) {
    function addWrapper(setup) {
      var wrapper = document.createElement("div"),
        $container = jQuery(container);

      // special case: when loading tools in the sidebar, some of those
      // are loaded in the appearance tab. Rather than create separate loaders
      // for each "container" we just branch here.
      // todo: load the appearance tool separately with a separate loader, load component
      // tools with their own loader as well
      var parent = "";

      if (setup.tool === "appearance" || setup.config.placement === "appearance") {
        parent = $container.find(".loaded-appearance");
      } else if (setup.tool === "behavior" || setup.config.placement === "behavior") {
        parent = $container.find(".loaded-behavior");
      } else if (setup.config.placement === "config") {
        parent = $container.find(".loaded-config");
      } else {
        parent = $container.find(".loaded-tools");
      }

      if (setup.config.display_size) {
        jQuery(wrapper).addClass(setup.config.display_size);
      }

      if (setup.config.group) {
        var groupName = setup.config.group;
        var groupClass = "grouped-tools--" + groupName;
        var group = parent.find("." + groupClass);
        if (!group[0]) {
          var group = jQuery("<div>");
          var groupLabel = jQuery("<label>");
          group.addClass("grouped-tools").addClass(groupClass);
          groupLabel.addClass("grouped-tools__label").text(groupName);
          group.append(groupLabel);
          parent.append(group);
        }

        parent = group;
      }

      if (parent.length) {
        parent.append(wrapper);
      } else {
        $container.append(wrapper);
      }
      return wrapper;
    }

    // Removes `element`, and its `.grouped-tools` parent once no tool is left in it.
    function removeWrapper(element) {
      var parent = element.parentNode;
      element.remove();
      if (
        parent &&
        parent.classList.contains("grouped-tools") &&
        !parent.querySelector(":scope > :not(.grouped-tools__label)")
      ) {
        parent.remove();
      }
    }

    function unload(tool, shouldUnbind) {
      var unloadError;

      jQuery(tool.element).off();
      if (shouldUnbind) {
        try {
          tool.unbind();
        } catch (error) {
          unloadError = error;
        }
      }

      try {
        tool.unload();
      } catch (error) {
        unloadError = unloadError || error;
      }

      if (unloadError) {
        throw unloadError;
      }
    }

    function unloadTools(tools, toolsToUnbind) {
      var unloadError;

      tools.forEach(function (tool) {
        try {
          unload(tool, toolsToUnbind.indexOf(tool) !== -1);
        } catch (error) {
          unloadError = unloadError || error;
        }
      });

      return unloadError;
    }

    function load(setup) {
      var element = addWrapper(setup);
      var tool;

      try {
        tool = Tool.initialize(setup.tool, component.splinter(setup.contextName), {
          element: element,
          contextName: setup.contextName,
          config: setup.config || component.config,
        });
      } catch (error) {
        removeWrapper(element);
        throw error;
      }

      tool.setup = setup;
      return tool;
    }

    var loader = {
      component: component,
      container: container,
      loaded: [],
      tools: function (attributes, prefix) {
        var temp = jQuery
          .map(attributes, function (attribute, name) {
            return {
              tool: attribute.tool,
              contextName: prefix + name,
              config: attribute,
            };
          })
          .filter(function (attr) {
            return !!attr.tool;
          });
        return temp;
      },

      reload: function (tool) {
        var index = this.loaded.indexOf(tool);
        // Every loader receives `pb:tool:outdated`. Only the loader holding `tool` reloads it.
        if (index === -1) {
          return;
        }

        // reload the tool.
        var reloaded = load(tool.setup);

        // for some reason the restored context isn't making it's way back to
        // this loader, so i'm manually copying the old tool's component (which
        // has been restore) to the new reloaded tool, so the values are actually
        // reset.
        reloaded.component = tool.component;

        // replace the original tool on the page with the new tool.
        // also in the loaded tools array.
        jQuery(reloaded.element).html("");
        jQuery(tool.element).replaceWith(reloaded.element);
        this.loaded[index] = reloaded;

        try {
          unload(tool, true);
        } catch (cleanupError) {
          console.error("Tool loader cleanup failed while reloading a tool", cleanupError);
        }

        try {
          reloaded.load();
        } catch (error) {
          this.loaded.splice(this.loaded.indexOf(reloaded), 1);
          try {
            unload(reloaded, true);
          } catch (cleanupError) {
            console.error("Tool loader cleanup failed after a reload error", cleanupError);
          }
          removeWrapper(reloaded.element);
          throw error;
        }

        // The replacement element starts visible, so apply `show_if` to it again.
        this.runDependenciesChecks();

        return reloaded;
      },

      /**
       * dependencies, Checks all loaded tools to see if they are dependent on another tool in order to be seen by the
       * end user. Tools that are dependent set the 'dependent' node to the contextName of the tool they are depending
       * on. Tools that provide context to dependent, known here as providers, can set their 'unlockDependents' value
       * to true or false to show or hide dependent tools
       */
      runDependenciesChecks: function () {
        evaluateAllToolDependencies.bind(this)();

        function evaluateAllToolDependencies() {
          jQuery.each(this.loaded, handleToolDependencies.bind(this));
        }

        function handleToolDependencies(index, tool) {
          if (tool.showIf) {
            evaluateToolDependencies(
              this.component,
              tool.showIf,
              function () {
                jQuery(tool.element).show();
              },
              function () {
                jQuery(tool.element).hide();
              },
            );
          }
        }

        function evaluateToolDependencies(component, conditionNode, conditionsMetAction, conditionsFailedAction) {
          var conditionsMet = true;
          var context = component.context;

          if (component.shared) {
            context = component.blendedData().context;
          }

          for (var key in conditionNode) {
            if (key in context) {
              conditionsMet = context[key] === conditionNode[key];
              if (!conditionsMet) {
                break;
              }
            } else {
              conditionsMet = false;
              break;
            }
          }

          if (conditionsMet) {
            conditionsMetAction();
          } else {
            conditionsFailedAction();
          }
        }
      },

      load: function (attributes, prefix) {
        var activatedTools = [];
        var isOutermostLoad = loadDepth === 0;

        loadDepth++;

        try {
          if (isOutermostLoad) {
            Event.trigger("pb:tools:load:start");
          }

          try {
            Event.on("pb:tool:outdated", this.reload, this);
            Event.on("pb:component:save", this.runDependenciesChecks, this);

            prefix = prefix || "";
            // by default load all the global tools and component tools
            var toLoad;

            if (!attributes) {
              // some tools are not mapped to an attribute
              var globalTools = Tool.globalTools(component),
                componentTools = this.tools(component.config.attributes, prefix);
              toLoad = globalTools.concat(componentTools);
            } else {
              toLoad = this.tools(attributes, prefix);
            }

            // Pushed one at a time so `this.loaded` holds every tool initialized before a failure.
            toLoad.forEach(
              function (setup) {
                this.loaded.push(load(setup));
              }.bind(this),
            );

            this.loaded.forEach(function (tool) {
              // Recorded before load() so a tool whose load throws is still unbound.
              activatedTools.push(tool);
              tool.load();
            });

            // Trigger Dependency lookup
            this.runDependenciesChecks();
          } catch (error) {
            var failedTools = this.loaded;

            this.loaded = [];
            Event.off(null, null, this);
            var cleanupError = unloadTools(failedTools, activatedTools);
            failedTools.forEach(function (tool) {
              removeWrapper(tool.element);
            });

            if (cleanupError) {
              console.error("Tool loader cleanup failed after a load error", cleanupError);
            }
            throw error;
          }
        } finally {
          loadDepth--;
          if (loadDepth === 0) {
            Event.trigger("pb:tools:load:done");
          }
        }
      },
      unload: function () {
        var unloadError;
        var tools = this.loaded;

        this.loaded = [];
        Event.off(null, null, this);
        unloadError = unloadTools(tools, tools);
        this.container.innerHTML = "";

        if (unloadError) {
          throw unloadError;
        }
      },
    };

    return loader;
  }

  Tool.Loader = Loader;
})(Sparkle.PageBuilder.Tool, Sparkle.PageBuilder.Helpers.Event);
